var exports = {
  "MY": "OAuthAuthorizePage.module__page___RGJXa1",
  "Un": "OAuthAuthorizePage.module__errorContainer___RGJXa1",
  "ow": "OAuthAuthorizePage.module__errorContent___RGJXa1",
  "JU": "OAuthAuthorizePage.module__errorTitle___RGJXa1",
  "kc": "OAuthAuthorizePage.module__errorText___RGJXa1",
  "d1": "OAuthAuthorizePage.module__heroCard___RGJXa1",
  "iC": "OAuthAuthorizePage.module__heroCopy___RGJXa1",
  "ZY": "OAuthAuthorizePage.module__heroTitle___RGJXa1",
  "fd": "OAuthAuthorizePage.module__heroDescription___RGJXa1",
  "$2": "OAuthAuthorizePage.module__cardGrid___RGJXa1",
  "ts": "OAuthAuthorizePage.module__sectionDivider___RGJXa1",
  "nd": "OAuthAuthorizePage.module__panel___RGJXa1",
  "bV": "OAuthAuthorizePage.module__sectionHeader___RGJXa1",
  "Gf": "OAuthAuthorizePage.module__sectionTitle___RGJXa1",
  "yV": "OAuthAuthorizePage.module__sectionDescription___RGJXa1",
  "s0": "OAuthAuthorizePage.module__inlineStatus___RGJXa1",
  "Jb": "OAuthAuthorizePage.module__scopeList___RGJXa1",
  "_9": "OAuthAuthorizePage.module__permissionScrollContainer___RGJXa1",
  "C6": "OAuthAuthorizePage.module__permissionScroller___RGJXa1",
  "Mg": "OAuthAuthorizePage.module__permissionList___RGJXa1",
  "ce": "OAuthAuthorizePage.module__permissionRow___RGJXa1",
  "Ck": "OAuthAuthorizePage.module__permissionLabel___RGJXa1",
  "rJ": "OAuthAuthorizePage.module__scopeRow___RGJXa1",
  "BB": "OAuthAuthorizePage.module__scopeHeading___RGJXa1",
  "OK": "OAuthAuthorizePage.module__scopeName___RGJXa1",
  "RJ": "OAuthAuthorizePage.module__scopeDescription___RGJXa1",
  "Pp": "OAuthAuthorizePage.module__scopeChip___RGJXa1",
  "p$": "OAuthAuthorizePage.module__emptyState___RGJXa1",
  "uL": "OAuthAuthorizePage.module__caution___RGJXa1",
  "iB": "OAuthAuthorizePage.module__dangerNotice___RGJXa1",
  "mW": "OAuthAuthorizePage.module__successScreen___RGJXa1",
  "n7": "OAuthAuthorizePage.module__successIconCircle___RGJXa1",
  "FU": "OAuthAuthorizePage.module__successIcon___RGJXa1",
  "QK": "OAuthAuthorizePage.module__successTitle___RGJXa1",
  "s3": "OAuthAuthorizePage.module__successSubtitle___RGJXa1",
  "cs": "OAuthAuthorizePage.module__successAction___RGJXa1",
  "By": "OAuthAuthorizePage.module__guildOption___RGJXa1",
  "rZ": "OAuthAuthorizePage.module__guildValue___RGJXa1",
  "XN": "OAuthAuthorizePage.module__guildAvatar___RGJXa1",
  "oM": "OAuthAuthorizePage.module__guildAvatarPlaceholder___RGJXa1",
  "p2": "OAuthAuthorizePage.module__guildOptionLabel___RGJXa1",
  "RG": "OAuthAuthorizePage.module__guildOptionDisabled___RGJXa1",
  "p4": "OAuthAuthorizePage.module__guildOptionNotice___RGJXa1",
  "A2": "OAuthAuthorizePage.module__actionSection___RGJXa1",
  "PJ": "OAuthAuthorizePage.module__footerText___RGJXa1",
  "o1": "OAuthAuthorizePage.module__actions___RGJXa1",
  "hP": "OAuthAuthorizePage.module__actionButton___RGJXa1",
  "U6": "OAuthAuthorizePage.module__authorizingAccount___RGJXa1",
  "HI": "OAuthAuthorizePage.module__authorizingAccountAvatar___RGJXa1",
  "vZ": "OAuthAuthorizePage.module__authorizingAccountText___RGJXa1",
};

module.exports = exports;
